module.exports = function() {
	return new Worker(__webpack_public_path__ + "e35b9fbd3359dbde88eb.shapes.wrkr.js");
};